import { BSDataWithHistory, DataBudget } from "../types";

export const mergeDataWithBudget = (data: BSDataWithHistory[], dataBudget: DataBudget[]) => {
  return data.map(coa => {
    const match = dataBudget.find(b => b.coa_id === coa.coa_id);

    if (match) {
      const { coa_id, ...periodBalances } = match;
      return { ...coa, period_balance: periodBalances };
    }

    return { ...coa, period_balance: {} };
  });
}